import { useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './pages/admin/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';

// public pages
import HomePage from "./pages/HomePage";
import Academy from "./pages/Academy";
import AcademyMore from "./pages/AcademyMore";
import Contact from './pages/Contact';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import PortfolioAll from './pages/PortfolioAll';
import SubBrandGallery from './pages/SubBrandGallery';
import Investment from './pages/Investment';
import HomeBlog from './pages/Blog';
import MainBlog from './pages/MainBlog';
import Offer from './pages/Offer';
import ThankYou from './pages/ThankYou';

// admin pages
import Blog from './pages/admin/Blog';
import PostBlog from './pages/admin/PostBlog';
import EditBlog from './pages/admin/EditBlog';
// import Register from './pages/admin/Register';
import AdminContact from './pages/admin/Contact';
import AdminAcademy from './pages/admin/Academy';
import Subscribers from './pages/admin/Subscribers';
import Bookings from './pages/admin/Bookings';
import TcqApplications from './pages/admin/TcqApplications';
import Brand from './pages/admin/BrandForm';
import EditBrand from './pages/admin/EditBrandForm';
import SubBrand from './pages/admin/SubBrandForm';
import ImageUploadForm from './pages/admin/ImageUploadForm';
import SubbrandImageUpload from './pages/admin/SubbrandImageUpload';
import AdminPortfolio from './pages/admin/Portfolio';
import Login from './pages/admin/Login';
import Home from './pages/admin/Index';
import CreatePost from './pages/admin/CreatePost';

const App = () => {
  const [setIsLoggedIn] = useState(false)
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/community" element={<Academy />} />
          <Route path="/community/the-creative-quarters" element={<AcademyMore />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<PortfolioAll />} />
          <Route path="/investment" element={<Investment />} />
          <Route path="/portfolio/:brandName" element={<Portfolio />} />
          <Route
            path="/portfolio/:brandName/:subBrandSlug"
            element={<SubBrandGallery />}
          />
          <Route path="/blog" element={<MainBlog />} />
          <Route path="/blog/:slug" element={<HomeBlog />} />
          <Route path="/offer" element={<Offer />} />
          <Route path="/thank-you" element={<ThankYou />} />

          {/* Auth route (public) */}
          <Route path="/admin/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
          {/*<Route path="/admin/register" element={<Register setIsLoggedIn={setIsLoggedIn} />} />*/}

          {/* Protected admin routes */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <Routes>
                  <Route path="home" element={<Home />} />
                  <Route path="blog" element={<Blog />} />
                  <Route path="blog/:id" element={<PostBlog />} />
                  <Route path="edit/:id" element={<EditBlog />} />
                  <Route path="contact" element={<AdminContact />} />
                  <Route path="academy" element={<AdminAcademy />} />
                  <Route path="subscribers" element={<Subscribers />} />
                  <Route path="bookings" element={<Bookings />} />
                  <Route path="tcq-applications" element={<TcqApplications />} />
                  <Route path="portfolio" element={<Brand />} />
                  <Route path="editbrand" element={<EditBrand />} />
                  <Route path="sub-portfolio" element={<SubBrand />} />
                  <Route path="upload-to-portfolio" element={<ImageUploadForm />} />
                  <Route path="upload-to-subportfolio" element={<SubbrandImageUpload />} />
                  <Route path="portfolio/:id" element={<AdminPortfolio />} />
                  <Route path="create" element={<CreatePost />} />
                </Routes>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
